import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'morva-sort-button',
  templateUrl: './sort-button.component.html',
  styleUrl: './sort-button.component.scss'
})
export class SortButtonComponent {

  readonly defaultColor = '#808080';
  readonly activeColor = '#009fe3';

  @Input() loading!: boolean;
  @Input() ascending!: boolean;
  @Output() sortChange = new EventEmitter<boolean>();

  get upColor() {
    return this.ascending ? this.activeColor : this.defaultColor;
  }

  get downColor() {
    return this.ascending === false ? this.activeColor : this.defaultColor;
  }
  
  toggle() {
    this.sortChange.emit(!this.ascending);
  }
}
